(ns practitest.frontend.components2.dashboard.transforms.line
  (:require ["d3" :as d3]
            [practitest.frontend.components2.dashboard.schema :as sc]
            [practitest.frontend.components2.dashboard.helpers :as h]))

(def ^:private parse-category-date (.utcParse d3 "%Y-%b-%d"))

(def LineItem
  [:map
   [:date  inst?]
   [:group :string]
   [:value number?]])

(def LineSeriesData
  [:map
   [:chart/data [:vector LineItem]]
   [:chart/inactive-groups [:vector [:string]]]
   [:chart/categories [:vector inst?]]
   [:chart/series [:vector [:string]]]
   [:chart/x-label-visible-step [:maybe :int]]])

(defn transform
  {:malli/schema
   [:=> [:cat [:map
               [:chart/data sc/SeriesCategories]
               [:chart/cell-width {:optional true} [:maybe [:enum :regular :double :triple]]]]]
    LineSeriesData]}
  [{{:keys [series categories]} :chart/data
    :chart/keys                 [toggle-legend cell-width]
    :or                         {toggle-legend {}}
    :as                         chart}]
  (let [active?              #(toggle-legend % true)
        a-series             (h/active-series series active?)
        categories-count     (count categories)
        parsed-categories    (mapv parse-category-date categories)
        x-label-visible-step (h/x-label-visible-step categories-count cell-width)
        inactive-groups      (->> series
                                  (remove #(some #{(:name %)} (map :name a-series)))
                                  (mapv :name))]

    (merge chart
           {:chart/data
            (vec
              (mapcat (fn [idx date]
                        (keep (fn [{group :name data :data}]
                                (when-some [value (nth data idx nil)]
                                  {:date  date
                                   :group group
                                   :value value}))
                              a-series))
                      (range categories-count)
                      parsed-categories))

            :chart/inactive-groups      inactive-groups
            :chart/categories           parsed-categories
            :chart/series               (mapv :name series)
            :chart/x-label-visible-step x-label-visible-step})))